// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { AuthResource } from 'components';
import { toast } from 'react-toastify';

const UserActionsMob = ({
    auth,
    data,
    history,
    isEditOnly,
    tableType,
}) => {
    const handleEditView = actionType => {
        if (isEditOnly) {
            history.push(`/tid-onboarding/create/terminal`);
        } else {
            const { entityCode } = data.original;
            if (actionType === 'edit') {
                history.push(`/tid-onboarding/edit/terminal/${entityCode}`);
            } else if (actionType === 'view') {
                history.push(`/tid-onboarding/view/terminal/${entityCode}`);
            }
        }
    };
    // only in case when user has view_Tid request 
    const handleEditClick =() =>{
        toast.error('Access Denied. User doesnt have required permissions. Please contact support.');
    }

    const hasEditPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('edit_tid');
    const hasViewPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('view_tid');
    const hasCreatePermission = auth?.resourceDetails?.permissions?.merchant_onboarding?.includes('create_merchant');
    return (
        <div className="userAction multiItem">
            {tableType !== 'inactive' ? (
                <>
                    {hasCreatePermission ? (
                        <>
                            <button
                                className="edit"
                                id="edit-merchant"
                                onClick={() => handleEditView('edit')}
                            />
                            <button
                                className="view"
                                id="view-merchant"
                                onClick={() => handleEditView('view')}
                            />
                        </>
                    ) : (
                        <>
                            {hasEditPermission && (
                                <button
                                    className="edit"
                                    id="edit-merchant"
                                    onClick={() => handleEditView('edit')}
                                />
                            )}

                            {hasViewPermission && !hasEditPermission && (
                                <button
                                    className="edit"
                                    id="edit-merchant"
                                    onClick={handleEditClick}
                                />
                            )}

                            {tableType !== 'draft' && (
                                <button
                                    className="view"
                                    id="view-merchant"
                                    onClick={() => handleEditView('view')}
                                />
                            )}
                        </>
                    )}
                </>
            ) : (
                <>
                    <button
                        className={`edit ${!data.original.isEditMode ? 'block' : ''}`}
                        id="edit-merchant"
                        onClick={() => handleEditClick()}
                        disabled={!data.original.isEditMode}
                    />
                </>
            )}
        </div>
    );

};

UserActionsMob.propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object,
    isEditOnly: PropTypes.bool,
    tableType: PropTypes.string,
};

export default withRouter(UserActionsMob);
